import {Api} from './config/request';

const getAttendanceForClass = (classID) => (Api.getFliveRequest(`classes/${classID}/attendance`,true));

export const AttendanceApiCalls = {
    getAttendanceForClass,
}